var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubsArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33313 11.7815L1.94246 7.39079L0.0571289 9.27612L6.33313 15.5521L19.2758 2.60945L17.3905 0.724121L6.33313 11.7815Z",
    fill: "#3b82f6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubsArrow);
export default __webpack_public_path__ + "static/media/Subs-arrow.60307694591d837596d1f67620fa1f57.svg";
export { ForwardRef as ReactComponent };